import { useState } from "react";
import { Box } from "@mui/material";
import { OrganizationListView } from "./components/OrganizationListView";
import { OrganizationRecapView } from "./components/OrganizationRecapView";
import { OrganizationDto } from "src/data/admin/types/organization";

const Organizations = () => {
  const [selectedOrgId, setSelectedOrgId] = useState<string | null>(null);

  const handleSelect = (org: OrganizationDto) => setSelectedOrgId(org.id);
  const handleBack = () => setSelectedOrgId(null);
  const handleDeleted = () => setSelectedOrgId(null);
  const handleUpdated = (_org: OrganizationDto) => {};

  return (
    <Box>
      {selectedOrgId === null ? (
        <OrganizationListView onSelect={handleSelect} />
      ) : (
        <OrganizationRecapView
          orgId={selectedOrgId}
          onBack={handleBack}
          onDeleted={handleDeleted}
          onUpdated={handleUpdated}
        />
      )}
    </Box>
  );
};

export default Organizations;
